module.exports = "<p>{{mtu|e}}</p>\n";
